import { Loader2 } from "lucide-react";

export function LoadMoreButton({ onClick, loading, testId }) {
  return (
    <div className="flex justify-center pt-4">
      <button
        data-testid={testId}
        onClick={onClick}
        disabled={loading}
        className="inline-flex items-center gap-2 rounded-full border border-slate-700 hover:border-sky-500/50 text-slate-300 hover:text-slate-100 px-5 py-2 text-sm transition-colors disabled:opacity-60"
      >
        {loading && <Loader2 className="w-4 h-4 animate-spin" />} Carregar mais
      </button>
    </div>
  );
}

export default LoadMoreButton;
